//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import { get, post, put, deletes } from '@/api/fetch.js';
import url from '@/api/serviceAPI.config.js';
export default {
  name: 'tabs',
  data: function data() {
    return {
      tableHeight: document.body.clientHeight - 310,
      message: 'first',
      showHeader: false,
      earlyWarning: null,
      farmerRemind: null,
      task: null,
      earlyWarningList: [],
      farmerRemindList: [],
      taskList: [],
      readState: null,
      warningName: null,
      deviceName: null,
      pageNum: 0,
      pageSize: 10,
      readState2: null,
      remindTitle: null,
      pageNum2: 0,
      pageSize2: 10,
      readState3: null,
      taskName: null,
      pageNum3: 0,
      pageSize3: 10,
      listLoading: false,
      total: null,
      total2: null,
      total3: null,
      sels: null,
      sels2: null,
      sels3: null,
      devideList: [],
      dialog: false,
      detailId: null,
      dialog2: false,
      detailId2: null,
      dialogT: false,
      detailIdT: null
    };
  },
  created: function created() {
    this.getNum();
    this.geteEarlyWarningList();
    this.getFarmerRemindList();
    this.getTaskList();
    this.getDevide();
  },
  methods: {
    checkSelectable: function checkSelectable(row) {
      return row.readState != 0;
    },
    handleRead: function handleRead(index) {
      var item = this.unread.splice(index, 1);
      console.log(item);
      this.read = item.concat(this.read);
    },
    //改变分页信息
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNum = val - 1;
      this.geteEarlyWarningList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.geteEarlyWarningList();
    },
    handleCurrentChange2: function handleCurrentChange2(val) {
      this.pageNum2 = val - 1;
      this.getFarmerRemindList();
    },
    handleSizeChange2: function handleSizeChange2(val) {
      this.pageSize2 = val;
      this.getFarmerRemindList();
    },
    handleCurrentChange3: function handleCurrentChange3(val) {
      this.pageNum3 = val - 1;
      this.getTaskList();
    },
    handleSizeChange3: function handleSizeChange3(val) {
      this.pageSize3 = val;
      this.getTaskList();
    },
    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    selsChange2: function selsChange2(sels) {
      this.sels2 = sels;
    },
    selsChange3: function selsChange3(sels) {
      this.sels3 = sels;
    },
    getNum: function getNum() {
      var _this = this;
      get(url.inMal.inMailFetchRegistry).then(function (res) {
        _this.farmerRemind = res.data.farmerRemind;
        _this.task = res.data.task;
        _this.earlyWarning = res.data.earlyWarning;
      }).catch(function (err) {
        console.log(err);
      });
    },
    geteEarlyWarningList: function geteEarlyWarningList() {
      var _this2 = this;
      this.listLoading = true;
      get(url.inMal.inMailFindEarlyWarning, {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        readState: this.readState,
        warningName: this.warningName,
        deviceName: this.deviceName
      }).then(function (res) {
        _this2.earlyWarningList = res.datas;
        _this2.total = res.totalNum;
        _this2.listLoading = false;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getFarmerRemindList: function getFarmerRemindList() {
      var _this3 = this;
      this.listLoading = true;
      get(url.inMal.inMailFindFarmerRemind, {
        pageNum: this.pageNum2,
        pageSize: this.pageSize2,
        readState: this.readState2,
        remindTitle: this.remindTitle
      }).then(function (res) {
        _this3.farmerRemindList = res.datas;
        _this3.total2 = res.totalNum;
        _this3.listLoading = false;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getTaskList: function getTaskList() {
      var _this4 = this;
      this.listLoading = true;
      get(url.inMal.inMailFindTask, {
        pageNum: this.pageNum3,
        pageSize: this.pageSize3,
        readState: this.readState3,
        taskName: this.taskName
      }).then(function (res) {
        _this4.taskList = res.datas;
        _this4.total3 = res.totalNum;
        _this4.listLoading = false;
      }).catch(function (err) {
        console.log(err);
      });
    },
    //标记已读
    markedRead: function markedRead(id, type) {
      var _this5 = this;
      // 创建实例时设置配置的默认值
      var instance = axios.create();
      // 在实例已创建后修改默认值
      instance.defaults.headers.post['Content-Type'] = 'application/json';
      instance.post(url.inMal.inMailAdd, [{
        dataId: id,
        readState: 0,
        type: type
      }]).then(function (res) {
        if (res.status == 200) {
          _this5.$message({
            message: '操作成功',
            type: 'success',
            duration: 1000
          });
          _this5.geteEarlyWarningList();
          _this5.getFarmerRemindList();
          _this5.getTaskList();
          _this5.getNum();
        } else {
          _this5.$message.err('操作失败');
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    //批量标记已读
    batchMarkedRead: function batchMarkedRead(type) {
      var _this6 = this;
      if (type == 'earlyWarning') {
        if (this.sels.length < 1) {
          this.$message.error("请选择需要标记的信息！");
        } else {
          var pm = [];
          for (var i = 0; i < this.sels.length; i++) {
            var obj = {
              dataId: this.sels[i].id,
              readState: 0,
              type: 'earlyWarning'
            };
            pm.push(obj);
          }
        }
      } else if (type == 'farmerRemind') {
        if (this.sels2.length < 1) {
          this.$message.error("请选择需要标记的信息！");
        } else {
          var pm = [];
          for (var i = 0; i < this.sels2.length; i++) {
            var obj = {
              dataId: this.sels2[i].id,
              readState: 0,
              type: 'farmerRemind'
            };
            pm.push(obj);
          }
        }
      } else if (type == 'task') {
        if (this.sels3.length < 1) {
          this.$message.error("请选择需要标记的信息！");
        } else {
          var pm = [];
          for (var i = 0; i < this.sels3.length; i++) {
            var obj = {
              dataId: this.sels3[i].id,
              readState: 0,
              type: 'task'
            };
            pm.push(obj);
          }
        }
      }
      // 创建实例时设置配置的默认值
      var instance = axios.create();
      // 在实例已创建后修改默认值
      instance.defaults.headers.post['Content-Type'] = 'application/json';
      instance.post(url.inMal.inMailAdd, pm).then(function (res) {
        if (res.status == 200) {
          _this6.$message({
            message: '操作成功',
            type: 'success',
            duration: 1000
          });
          _this6.geteEarlyWarningList();
          _this6.getFarmerRemindList();
          _this6.getTaskList();
          _this6.getNum();
        } else {
          _this6.$message.err('操作失败');
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    //查询站点
    getDevide: function getDevide() {
      var _this7 = this;
      get(url.video.listDevice).then(function (res) {
        console.log(res);
        _this7.devideList = res.data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    //人员详情侧边框
    goDetail: function goDetail(id) {
      this.detailId = id;
      this.dialog = true;
    },
    goDetail2: function goDetail2(id) {
      this.detailId2 = id;
      this.dialog2 = true;
    },
    goDetail3: function goDetail3(id) {
      this.detailIdT = id;
      this.dialogT = true;
    }
  },
  computed: {}
};